// Modal.jsx
import React from "react";
import ReactDOM from "react-dom";

import styles from '../styles/DynamicModal.module.css';

import IconContainer from './IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

const modalRoot = document.getElementById("modal-root") || document.body;

export default function ModalRight({ isOpen, onClose, headline, children }) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.liningOver}>
        {children}
    </div>,
    modalRoot
  );
}
